// `ActivityType.systemImage` (GroundTeam/Models/Activity.swift) as lucide glyphs, for the history and upcoming lists.

import {
  ArrowLeftRight,
  Camera,
  CircleCheck,
  CirclePlus,
  FileText,
  Mail,
  MapPinned,
  MessageSquare,
  Phone,
  StickyNote,
  UserPlus,
  Users,
  type LucideIcon,
} from 'lucide-react';
import type { ActivityType } from '@/contracts/enums';

/** mappin.and.ellipse, phone, envelope, message, note.text, person.2, checkmark.circle, arrow.left.arrow.right,
 * person.badge.plus, plus.circle, camera, doc. */
export const ACTIVITY_ICONS: Readonly<Record<ActivityType, LucideIcon>> = {
  visit: MapPinned,
  call: Phone,
  email: Mail,
  text: MessageSquare,
  note: StickyNote,
  meeting: Users,
  task: CircleCheck,
  stageChange: ArrowLeftRight,
  assignment: UserPlus,
  created: CirclePlus,
  photo: Camera,
  document: FileText,
};
